"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byIds = byIds;
exports.byIdsStr = byIdsStr;

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _params = require("hub-http/helpers/params");

var TICKET_ID_KEY = 'id';

function byIds(ticketIds) {
  (0, _invariant.default)(_immutable.List.isList(ticketIds), 'TicketsAPIQuery: expected ticketIds to be a List but got %s', ticketIds);
  return (0, _immutable.Map)().set(TICKET_ID_KEY, ticketIds);
}

function byIdsStr(ticketIds) {
  return (0, _params.stringify)(byIds(ticketIds).toJS());
}